'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:SetupScheduleController
 * @description
 * # SetupScheduleController
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('ListGridController', ['$scope', '$routeParams', 'ListGrid', 'ListGridStatus', 'GridService', 'FlashService', 'ListGridConstants',
    function ($scope, $routeParams, ListGrid, ListGridStatus, GridService, FlashService, ListGridConstants) {

        var key = 'PK_RSACT';
        var value = $routeParams[key];

        ListGridStatus.gridId = $routeParams.grid;

        $scope.grid = new ListGrid(ListGridConstants.Types.Setup);

        function loadData(onlyRefreshData) {

            $scope.grid.showGrid = false;
            FlashService.ShowProgressBar();

            GridService.GetGrid(ListGridStatus.gridId).then(function (result) {

                $scope.grid.gridData = $scope.grid.getGridData($scope, result.data, onlyRefreshData);               

                $scope.grid.showGrid = true;
                FlashService.HideProgressBar();

                if (value) {
                    $scope.grid.editDialogData = { key: key, value: value };
                }
            });
        }

        loadData();
        
  }]);